import NovalueCheck from './NoValueCheck';

export default (value) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  if(value.indexOf('*/') >= 0) {
    value = value.split('*/');
  } else {
    value = value.split('/');
  }

  const sys = +value[0];
  const dia = +value[1];

  // ค่าปกติ: BPS 90-139, BPD 60-89
  if(sys >= 90 && sys <= 139 && dia >= 60 && dia <= 89) {
    return {
      title: 'ความดันปกติ',
      color: 'green',
      caption: 'ความดันปกติ',
      suggest: 'ควบคุมอาหาร ลดเค็ม และออกกำลังกาย'
    };
  }

  if(sys >= 180 || dia >= 110) {
    return {
      title: 'ความดันสูงวิกฤติ',
      color: 'red',
      caption: 'ความดันสูงมากอาจเป็นอันตรายหากไม่ได้รับการรักษา',
      suggest: 'ควรปรึกษาแพทย์เพื่อรักษา หรือรับประทานยาอย่างสม่ำเสมอ'
    };
  }

  if(sys >= 160 || dia >= 100) {
    return {
      title: 'ความดันสูงมาก',
      color: 'red',
      caption: 'ความดันสูงมากอาจเป็นอันตรายหากไม่ได้รับการรักษา',
      suggest: 'ควรปรึกษาแพทย์เพื่อรักษา หรือรับประทานยาอย่างสม่ำเสมอ'
    };
  }

  if(sys >= 140 || dia >= 90) {
    return {
      title: 'ความดันสูง',
      color: 'red',
      caption: 'ความดันสูงกว่าปกติ',
      suggest: 'ควบคุมอาหาร ลดเค็ม และออกกำลังกาย ปรึกษาแพทย์เพื่อรักษา'
    };
  }

  if(sys < 90 || dia < 60) {
    return {
      title: 'ความดันต่ำกว่าปกติ',
      color: 'red',
      caption: 'ความดันต่ำกว่าปกติ',
      suggest: 'ควรปรึกษาแพทย์'
    };
  }

  return {
    title: 'ความดันปกติ',
    color: 'green',
    caption: 'ความดันปกติ',
    suggest: 'ควบคุมอาหาร ลดเค็ม และออกกำลังกาย'
  };
}
